import React, { useState } from "react";
import "../styles/Header.css";
import amazonLogo from "../images/amazon-com-logo.svg";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import { Link } from "react-router-dom";
import { useStateValue } from "../StateProvider";
import { auth } from "../firebase";

function Header() {
  const [{ basket, user }] = useStateValue();

  const handelAuthentication = () => {
    if (user) {
      // here i am saying if i clicked on the sign out button while there is a user actually signed in
      //  this with make him actually signed out

      auth.signOut();
    }
  };

  return (
    <div className="header">
      <Link to="/">
        <img className={"header__logo"} src={amazonLogo} alt="" />
      </Link>

      <div className="header__search">
        <input className="header__searchInput" type="text" />
        <SearchIcon className="header__searchIcon" />
      </div>

      <div className="header__nav">
        <div className="header__option">
          <span className="header__optionLineOne">
            {user ? auth.currentUser.email : "Hello Guest"}
          </span>
          <Link to={!user && "/login"}>
            <span
              className="header__optionLineTwo"
              onClick={handelAuthentication}
            >
              {user ? "Sign Out" : "Sign In"}
            </span>
          </Link>
        </div>

        <div className="header__option">
          <span className="header__optionLineOne">Returns</span>
          <span className="header__optionLineTwo">& Orders</span>
        </div>

        <div className="header__option">
          <span className="header__optionLineOne">Your</span>
          <span className="header__optionLineTwo">Prime</span>
        </div>

        <div className="header__optionBasket">
          <Link to="/checkout">
            <ShoppingBasketIcon />
          </Link>

          <span className="header_optionLineTwo header_basketCount">
            {basket.length}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Header;
